import { CUSTOM_STYLES } from "components/InputMUI/Select/constants"

export const DISCONTINUED_STYLES = {
  option: (provided, state) => {
    const { options, getOptionValue } = state.selectProps
    const { isDiscontinued } = options.find((opt) => getOptionValue(opt) === state.value)

    return {
      ...CUSTOM_STYLES.option(provided, state),
      color: !isDiscontinued ? "#000" : "#f05d5e"
    }
  }
}

export const PATTERNS_EU = [
  {
    label: "ASSIA",
    value: "ASSIA",
    colors: [
      {
        label: "WHITE",
        value: "WHITE"
      },
      {
        label: "BLACK",
        value: "BLACK"
      }
    ]
  },
  {
    label: "AVANTGARDE",
    value: "AVANTGARDE",
    colors: [
      { label: "KETCHUP", value: "KETCHUP" },
      { label: "WALNUT", value: "WALNUT" },
      { label: "PRISTINE", value: "PRISTINE" },
      { label: "ANGORA", value: "ANGORA" },
      { label: "BRULÉE", value: "BRULÉE" },
      { label: "INCENSE", value: "INCENSE" },
      { label: "LILAC", value: "LILAC" },
      { label: "VELVET", value: "VELVET" },
      { label: "ROSEWOOD", value: "ROSEWOOD" },
      { label: "SIENNA", value: "SIENNA" },
      { label: "ORCHIDEA", value: "ORCHIDEA" },
      { label: "AZALEA", value: "AZALEA" },
      { label: "SAUVIGNON", value: "SAUVIGNON" },
      { label: "CITRONELLE", value: "CITRONELLE" },
      { label: "AMBER", value: "AMBER" },
      { label: "CLEMENTINE", value: "CLEMENTINE" },
      { label: "SCARLET", value: "SCARLET" },
      { label: "SCUBA", value: "SCUBA" },
      { label: "ATLANTIC", value: "ATLANTIC" },
      { label: "PETROL", value: "PETROL" },
      { label: "ECLIPSE", value: "ECLIPSE" },
      { label: "CERAMIC", value: "CERAMIC" },
      { label: "CHROME", value: "CHROME" },
      { label: "CONCRETE", value: "CONCRETE" },
      { label: "MIDNIGHT", value: "MIDNIGHT" }
    ]
  },
  {
    label: "BELUGA",
    value: "BELUGA",
    colors: [
      { label: "CELESTIAL", value: "CELESTIAL" },
      { label: "BLACKBEARD", value: "BLACKBEARD" },
      { label: "BURGUNDY", value: "BURGUNDY" },
      { label: "DOVE GREY", value: "DOVE GREY" },
      { label: "DUNE", value: "DUNE" },
      { label: "MOCCA", value: "MOCCA" },
      { label: "OCHRE", value: "OCHRE" },
      { label: "OFF WHITE", value: "OFF WHITE" },
      { label: "PAPAYA", value: "PAPAYA" },
      { label: "PEARL GREY", value: "PEARL GREY" },
      { label: "PURE WHITE", value: "PURE WHITE" },
      { label: "LIGHT YELLOW", value: "LIGHT YELLOW" },
      { label: "CHERRY", value: "CHERRY" },
      { label: "WHITE CAP", value: "WHITE CAP" },
      { label: "TRUE BLUE", value: "TRUE BLUE" },
      { label: "FOREST", value: "FOREST" }
    ]
  },
  {
    label: "CARBON FIBER",
    value: "CARBON FIBER",
    colors: [
      { label: "BRONZE", value: "BRONZE" },
      { label: "COPPER", value: "COPPER" },
      { label: "JAVA", value: "JAVA" },
      { label: "TOFFEE", value: "TOFFEE" },
      { label: "GINGER", value: "GINGER" },
      { label: "VANILLA", value: "VANILLA" },
      { label: "ANTHRACITE", value: "ANTHRACITE" },
      { label: "GRANITE", value: "GRANITE" },
      { label: "AZURE", value: "AZURE" },
      { label: "GRAPHITE", value: "GRAPHITE" },
      { label: "PEARL WHITE", value: "PEARL WHITE" },
      { label: "SILVER", value: "SILVER" },
      { label: "BLACK", value: "BLACK" }
    ]
  },
  {
    label: "CHRONOS",
    value: "CHRONOS",
    colors: [
      { label: "SIBERIA", value: "SIBERIA" },
      { label: "BALTIC", value: "BALTIC" },
      { label: "BISCUIT", value: "BISCUIT" },
      { label: "MARINE", value: "MARINE" },
      { label: "CHÂTAIGNE", value: "CHÂTAIGNE" },
      { label: "ORANGE", value: "ORANGE" },
      { label: "PISTACHIO", value: "PISTACHIO" },
      { label: "PORT", value: "PORT" },
      { label: "ROT", value: "ROT" },
      { label: "SCHWARZ", value: "SCHWARZ" },
      { label: "MILK", value: "MILK" },
      { label: "NIMBUS", value: "NIMBUS" },
      { label: "MARZIPAN", value: "MARZIPAN" },
      { label: "MUSCAT", value: "MUSCAT" },
      { label: "TOBACCO", value: "TOBACCO" },
      { label: "PORTOBELLO", value: "PORTOBELLO" },
      { label: "SESAME", value: "SESAME" },
      { label: "TEAK", value: "TEAK" },
      { label: "CABERNET", value: "CABERNET" },
      { label: "CAYENNE", value: "CAYENNE" }
    ]
  },
  {
    label: "DAKAR",
    value: "DAKAR",
    colors: [
      { label: "BLACK", value: "BLACK" },
      { label: "WHITE", value: "WHITE" }
    ]
  },
  {
    label: "DIAMANTE",
    value: "DIAMANTE",
    colors: [
      { label: "CARBON", value: "CARBON" },
      { label: "ESPRESSO", value: "ESPRESSO" },
      { label: "GRAPEY", value: "GRAPEY" },
      { label: "HONEY", value: "HONEY" },
      { label: "INDIGO", value: "INDIGO" },
      { label: "IVORY", value: "IVORY" },
      { label: "LAVA", value: "LAVA" },
      { label: "METEOR", value: "METEOR" },
      { label: "MULBERRY", value: "MULBERRY" },
      { label: "OLIVE", value: "OLIVE" },
      { label: "OTOÑO", value: "OTOÑO" },
      { label: "REGATTA", value: "REGATTA" },
      { label: "SAGE", value: "SAGE" },
      { label: "SNOW", value: "SNOW" },
      { label: "SUNSET", value: "SUNSET" },
      { label: "TAUPE", value: "TAUPE" },
      { label: "POLAR", value: "POLAR" },
      { label: "TAPIOCA", value: "TAPIOCA" },
      { label: "TONIC", value: "TONIC" },
      { label: "MERCURY", value: "MERCURY" },
      { label: "VINTAGE", value: "VINTAGE" },
      { label: "PEPPER", value: "PEPPER" }
    ]
  },
  {
    label: "DOLCE",
    value: "DOLCE",
    colors: [
      { label: "BLACK", value: "BLACK" },
      { label: "IVORY", value: "IVORY" },
      { label: "ARTESIAN", value: "ARTESIAN" },
      { label: "CAMEL", value: "CAMEL" },
      { label: "CHOCOLATE", value: "CHOCOLATE" },
      { label: "INDIGO", value: "INDIGO" },
      { label: "DUNE", value: "DUNE" },
      { label: "ECRU", value: "ECRU" },
      { label: "BURGUNDY", value: "BURGUNDY" },
      { label: "JET", value: "JET" },
      { label: "LATTE", value: "LATTE" },
      { label: "METEOR", value: "METEOR" },
      { label: "MOCHA", value: "MOCHA" },
      { label: "MOSS", value: "MOSS" },
      { label: "MUSHROOM", value: "MUSHROOM" },
      { label: "PEACOCK", value: "PEACOCK" },
      { label: "POPPY", value: "POPPY" },
      { label: "RUSSET", value: "RUSSET" },
      { label: "TANGELO", value: "TANGELO" },
      { label: "WHITE", value: "WHITE" },
      { label: "GRASS", value: "GRASS" },
      { label: "MISTGREY", value: "MISTGREY" },
      { label: "RATTAN", value: "RATTAN" },
      { label: "MANGO", value: "MANGO" },
      { label: "POMACE", value: "POMACE" },
      { label: "LIMELIGHT", value: "LIMELIGHT" },
      { label: "QUETZAL", value: "QUETZAL" },
      { label: "SLATE", value: "SLATE" },
      { label: "PEWTER", value: "PEWTER" },
      { label: "COOLMIST", value: "COOLMIST" },
      { label: "BRAMBLE", value: "BRAMBLE" },
      { label: "CUMIN", value: "CUMIN" },
      { label: "FUCHSIA", value: "FUCHSIA" },
      { label: "CITRON", value: "CITRON" },
      { label: "FOG", value: "FOG" },
      { label: "LION", value: "LION" },
      { label: "SAND", value: "SAND" }
    ]
  },
  {
    label: "DOLCE C5",
    value: "DOLCE C5",
    colors: [
      { label: "ARTESIAN", value: "ARTESIAN" },
      { label: "WHITE", value: "WHITE" },
      { label: "IVORY", value: "IVORY" },
      { label: "LATTE", value: "LATTE" },
      { label: "CAMEL", value: "CAMEL" },
      { label: "MOCHA", value: "MOCHA" },
      { label: "CHOCOLATE", value: "CHOCOLATE" },
      { label: "BURGUNDY", value: "BURGUNDY" },
      { label: "GRASS", value: "GRASS" },
      { label: "MOSS", value: "MOSS" },
      { label: "PEACOCK", value: "PEACOCK" },
      { label: "INDIGO", value: "INDIGO" },
      { label: "BLACK", value: "BLACK" },
      { label: "GRANADILA", value: "GRANADILA" },
      { label: "MARSALA", value: "MARSALA" },
      { label: "PINETREE", value: "PINETREE" },
      { label: "CHARCOAL", value: "CHARCOAL" },
      { label: "CITRON", value: "CITRON" }
    ]
  },
  {
    label: "ENCORE",
    value: "ENCORE",
    colors: [
      { label: "ALABASTER", value: "ALABASTER" },
      { label: "MINERAL", value: "MINERAL" },
      { label: "NOIR", value: "NOIR" }
    ]
  },
  {
    label: "FAILLE",
    value: "FAILLE",
    colors: [
      { label: "TARTUFO", value: "TARTUFO" },
      { label: "FROST", value: "FROST" },
      { label: "RIVA", value: "RIVA" },
      { label: "AVENA", value: "AVENA" },
      { label: "BARLEY", value: "BARLEY" },
      { label: "SILVER", value: "SILVER" },
      { label: "CINNAMON", value: "CINNAMON" }
    ]
  },
  {
    label: "FINESSE",
    value: "FINESSE",
    colors: [
      { label: "TAUPE", value: "TAUPE" },
      { label: "PRALINÉ", value: "PRALINÉ" },
      { label: "METEOR", value: "METEOR" },
      { label: "PURE WHITE", value: "PURE WHITE" },
      { label: "LEINEN", value: "LEINEN" },
      { label: "BEIGE", value: "BEIGE" }
    ]
  },
  {
    label: "HITCH",
    value: "HITCH",
    colors: [
      { label: "MAHOGANY", value: "MAHOGANY" },
      { label: "NEUTRA", value: "NEUTRA" },
      { label: "PUTTY", value: "PUTTY" },
      { label: "LEAD", value: "LEAD" },
      { label: "CARBON", value: "CARBON" },
      { label: "PLATINUM", value: "PLATINUM" },
      { label: "ZINC", value: "ZINC" },
      { label: "ICEBERG", value: "ICEBERG" },
      { label: "AVALANCHE", value: "AVALANCHE" },
      { label: "SEASHELL", value: "SEASHELL" },
      { label: "STARFISH", value: "STARFISH" },
      { label: "LAKRITZ", value: "LAKRITZ" },
      { label: "TANGERINE", value: "TANGERINE" },
      { label: "BRILLIANT ORANGE", value: "BRILLIANT ORANGE" },
      { label: "LAVA", value: "LAVA" },
      { label: "RAISIN", value: "RAISIN" },
      { label: "INDIGO", value: "INDIGO" },
      { label: "SAPPHIRE", value: "SAPPHIRE" },
      { label: "CERULEAN", value: "CERULEAN" },
      { label: "PORCELAIN", value: "PORCELAIN" },
      { label: "PASTEL", value: "PASTEL" },
      { label: "LIMEADE", value: "LIMEADE" },
      { label: "JAVA", value: "JAVA" },
      { label: "METEORITE", value: "METEORITE" },
      { label: "ALLOY", value: "ALLOY" },
      { label: "SUNFLOWER", value: "SUNFLOWER" },
      { label: "FREESIA", value: "FREESIA" },
      { label: "CIRUELA", value: "CIRUELA" },
      { label: "ZEST", value: "ZEST" }
    ]
  },
  {
    label: "HITCH C5",
    value: "HITCH C5",
    colors: [
      { label: "CARBON", value: "CARBON" },
      { label: "AVALANCHE", value: "AVALANCHE" },
      { label: "STARFISH", value: "STARFISH" },
      { label: "SEASHELL", value: "SEASHELL" },
      { label: "PUTTY", value: "PUTTY" },
      { label: "ALLOY", value: "ALLOY" },
      { label: "LEAD", value: "LEAD" },
      { label: "NEUTRA", value: "NEUTRA" },
      { label: "JAVA", value: "JAVA" },
      { label: "CIRUELA", value: "CIRUELA" },
      { label: "RAISIN", value: "RAISIN" },
      { label: "LAVA", value: "LAVA" },
      { label: "TANGERINE", value: "TANGERINE" },
      { label: "INDIGO", value: "INDIGO" },
      { label: "SAPPHIRE", value: "SAPPHIRE" },
      { label: "CERULEAN", value: "CERULEAN" },
      { label: "ZEST", value: "ZEST" },
      { label: "ZINC", value: "ZINC" },
      { label: "LAKRITZ", value: "LAKRITZ" }
    ]
  },
  {
    label: "HORIZON",
    value: "HORIZON",
    colors: [
      { label: "ALPINE", value: "ALPINE" },
      { label: "IVOIRE", value: "IVOIRE" },
      { label: "BAMBOO", value: "BAMBOO" },
      { label: "ARGENTATO", value: "ARGENTATO" },
      { label: "SHADOW", value: "SHADOW" },
      { label: "AURUM", value: "AURUM" },
      { label: "SOIRÉE", value: "SOIRÉE" }
    ]
  },
  {
    label: "KIZUNA ARTISAN",
    value: "KIZUNA ARTISAN",
    colors: [
      { label: "LEADEN", value: "LEADEN" },
      { label: "MINT", value: "MINT" },
      { label: "SEAFOAM", value: "SEAFOAM" },
      { label: "CELESTE", value: "CELESTE" },
      { label: "WHEAT", value: "WHEAT" },
      { label: "TWILIGHT", value: "TWILIGHT" },
      { label: "SEAROCK", value: "SEAROCK" },
      { label: "BARK", value: "BARK" }
    ]
  },
  {
    label: "KIZUNA CHECKER",
    value: "KIZUNA CHECKER",
    colors: [
      { label: "OVERCAST", value: "OVERCAST" },
      { label: "WINTER", value: "WINTER" },
      { label: "CREAMY", value: "CREAMY" },
      { label: "CARDAMOM", value: "CARDAMOM" },
      { label: "BOBCAT", value: "BOBCAT" },
      { label: "ACQUA", value: "ACQUA" },
      { label: "CEDRUS", value: "CEDRUS" },
      { label: "KHAKI", value: "KHAKI" },
      { label: "STORMY", value: "STORMY" },
      { label: "CRYSTAL", value: "CRYSTAL" },
      { label: "KSAMIL", value: "KSAMIL" },
      { label: "SOOT", value: "SOOT" },
      { label: "ATLANTIC", value: "ATLANTIC" },
      { label: "SALVIA", value: "SALVIA" },
      { label: "EMERALD", value: "EMERALD" }
    ]
  },
  {
    label: "KIZUNA TWEED",
    value: "KIZUNA TWEED",
    colors: [
      { label: "SNOWY", value: "SNOWY" },
      { label: "OAT", value: "OAT" },
      { label: "OTTER", value: "OTTER" },
      { label: "FOGGY", value: "FOGGY" },
      { label: "ZEBRA", value: "ZEBRA" },
      { label: "CEDAR", value: "CEDAR" },
      { label: "ASHY", value: "ASHY" },
      { label: "DARKEST", value: "DARKEST" },
      { label: "BUFF", value: "BUFF" },
      { label: "CAPRI", value: "CAPRI" },
      { label: "JANUBIO", value: "JANUBIO" },
      { label: "MANGROVE", value: "MANGROVE" }
    ]
  },
  {
    label: "LIENZO",
    value: "LIENZO",
    colors: [
      { label: "BLACK", value: "BLACK" }
    ]
  },
  {
    label: "LINETEX",
    value: "LINETEX",
    colors: [
      { label: "MINT", value: "MINT" },
      { label: "BOND", value: "BOND" },
      { label: "FRAPPE", value: "FRAPPE" },
      { label: "NUT", value: "NUT" },
      { label: "TEJA", value: "TEJA" },
      { label: "MILOS", value: "MILOS" },
      { label: "ATITLAN", value: "ATITLAN" },
      { label: "ICELAND", value: "ICELAND" },
      { label: "MATCHA", value: "MATCHA" },
      { label: "EMERALD", value: "EMERALD" },
      { label: "MIST", value: "MIST" },
      { label: "BASSALT", value: "BASSALT" },
      { label: "WAVE", value: "WAVE" },
      { label: "CHALK", value: "CHALK" },
      { label: "BUTTER", value: "BUTTER" },
      { label: "DUST", value: "DUST" },
      { label: "TOAST", value: "TOAST" },
      { label: "CHESTNUT", value: "CHESTNUT" },
      { label: "ROCK", value: "ROCK" },
      { label: "IRON", value: "IRON" },
      { label: "CLIFF", value: "CLIFF" },
      { label: "SHALE", value: "SHALE" },
      { label: "SHALLOW", value: "SHALLOW" },
      { label: "TRUFFLE", value: "TRUFFLE" },
      { label: "SPHERE", value: "SPHERE" },
      { label: "GLACIER", value: "GLACIER" },
      { label: "CACAO", value: "CACAO" },
      { label: "BAMBOO", value: "BAMBOO" }
    ]
  },
  {
    label: "MAGLIA",
    value: "MAGLIA",
    colors: [
      { label: "AÇAI", value: "AÇAI" },
      { label: "ALASKA", value: "ALASKA" },
      { label: "ARCTIC", value: "ARCTIC" },
      { label: "ARMORY", value: "ARMORY" },
      { label: "ASH", value: "ASH" },
      { label: "BLACKCAVE", value: "BLACKCAVE" },
      { label: "BLOSSOM", value: "BLOSSOM" },
      { label: "BREEZE", value: "BREEZE" },
      { label: "DOVETAIL", value: "DOVETAIL" },
      { label: "EARTH", value: "EARTH" },
      { label: "FJORD", value: "FJORD" },
      { label: "GINGER", value: "GINGER" },
      { label: "GRANITE", value: "GRANITE" },
      { label: "GREENLAND", value: "GREENLAND" },
      { label: "GRIZZLY", value: "GRIZZLY" },
      { label: "HIVE", value: "HIVE" },
      { label: "INDIGO", value: "INDIGO" },
      { label: "KYANITE", value: "KYANITE" },
      { label: "MAPLE", value: "MAPLE" },
      { label: "MARS", value: "MARS" },
      { label: "MAUI", value: "MAUI" },
      { label: "MIDNIGHT", value: "MIDNIGHT" },
      { label: "MINUIT", value: "MINUIT" },
      { label: "MONOCHROME", value: "MONOCHROME" },
      { label: "OAK", value: "OAK" },
      { label: "PRIMROSE", value: "PRIMROSE" },
      { label: "SAFARI", value: "SAFARI" },
      { label: "SAGE", value: "SAGE" },
      { label: "SERENITY", value: "SERENITY" },
      { label: "SKY", value: "SKY" },
      { label: "SVALBARD", value: "SVALBARD" },
      { label: "TAHOE", value: "TAHOE" },
      { label: "THUNDER", value: "THUNDER" },
      { label: "TRUFFLE", value: "TRUFFLE" },
      { label: "URBAN", value: "URBAN" },
      { label: "UYUNI", value: "UYUNI" }
    ]
  },
  {
    label: "MAGLIA C5",
    value: "MAGLIA C5",
    colors: [
      { label: "UYUNI", value: "UYUNI" },
      { label: "GINGER", value: "GINGER" },
      { label: "OAK", value: "OAK" },
      { label: "ALASKA", value: "ALASKA" },
      { label: "THUNDER", value: "THUNDER" },
      { label: "GRANITE", value: "GRANITE" },
      { label: "ASH", value: "ASH" },
      { label: "BLOSSOM", value: "BLOSSOM" },
      { label: "ARCTIC", value: "ARCTIC" },
      { label: "FJORD", value: "FJORD" },
      { label: "BLACKCAVE", value: "BLACKCAVE" },
      { label: "INDIGO", value: "INDIGO" },
      { label: "HIVE", value: "HIVE" },
      { label: "MARS", value: "MARS" },
      { label: "PRIMROSE", value: "PRIMROSE" },
      { label: "MINUIT", value: "MINUIT" },
      { label: "KYANITE", value: "KYANITE" },
      { label: "SVALBARD", value: "SVALBARD" },
      { label: "TRUFFLE", value: "TRUFFLE" }
    ]
  },
  {
    label: "MAGLIA E-SENSE",
    value: "MAGLIA E-SENSE",
    colors: [
      { label: "AÇAI", value: "AÇAI" },
      { label: "ALASKA", value: "ALASKA" },
      { label: "ARCTIC", value: "ARCTIC" },
      { label: "ARMORY", value: "ARMORY" },
      { label: "ASH", value: "ASH" },
      { label: "BLACKCAVE", value: "BLACKCAVE" },
      { label: "BLOSSOM", value: "BLOSSOM" },
      { label: "BREEZE", value: "BREEZE" },
      { label: "DOVETAIL", value: "DOVETAIL" },
      { label: "EARTH", value: "EARTH" },
      { label: "FJORD", value: "FJORD" },
      { label: "GINGER", value: "GINGER" },
      { label: "GRANITE", value: "GRANITE" },
      { label: "GREENLAND", value: "GREENLAND" },
      { label: "GRIZZLY", value: "GRIZZLY" },
      { label: "HIVE", value: "HIVE" },
      { label: "INDIGO", value: "INDIGO" },
      { label: "KYANITE", value: "KYANITE" },
      { label: "MAPLE", value: "MAPLE" },
      { label: "MARS", value: "MARS" },
      { label: "MAUI", value: "MAUI" },
      { label: "MIDNIGHT", value: "MIDNIGHT" },
      { label: "MINUIT", value: "MINUIT" },
      { label: "MONOCHROME", value: "MONOCHROME" },
      { label: "OAK", value: "OAK" },
      { label: "PRIMROSE", value: "PRIMROSE" },
      { label: "SAFARI", value: "SAFARI" },
      { label: "SAGE", value: "SAGE" },
      { label: "SERENITY", value: "SERENITY" },
      { label: "SKY", value: "SKY" },
      { label: "SVALBARD", value: "SVALBARD" },
      { label: "TAHOE", value: "TAHOE" },
      { label: "THUNDER", value: "THUNDER" },
      { label: "TRUFFLE", value: "TRUFFLE" },
      { label: "URBAN", value: "URBAN" },
      { label: "UYUNI", value: "UYUNI" }
    ]
  },
  {
    label: "MARDI GRAS",
    value: "MARDI GRAS",
    colors: [
      { label: "AQUA", value: "AQUA" },
      { label: "AVOCADO", value: "AVOCADO" },
      { label: "BLUE SKY", value: "BLUE SKY" },
      { label: "CHARCOAL", value: "CHARCOAL" },
      { label: "CREAM", value: "CREAM" },
      { label: "CRIMSON", value: "CRIMSON" },
      { label: "DAMSON", value: "DAMSON" },
      { label: "DOLPHIN", value: "DOLPHIN" },
      { label: "FOREST", value: "FOREST" },
      { label: "FUCHSIA", value: "FUCHSIA" },
      { label: "GOBI", value: "GOBI" },
      { label: "LAVENDER", value: "LAVENDER" },
      { label: "MOCHA", value: "MOCHA" },
      { label: "MONROE", value: "MONROE" },
      { label: "NAVY", value: "NAVY" },
      { label: "PACIFIC", value: "PACIFIC" },
      { label: "SMOKE", value: "SMOKE" },
      { label: "SNOW", value: "SNOW" },
      { label: "TANGERINE", value: "TANGERINE" }
    ]
  },
  {
    label: "MARLIN",
    value: "MARLIN",
    colors: [
      { label: "CELESTIAL", value: "CELESTIAL" },
      { label: "AQUA MARINE", value: "AQUA MARINE" },
      { label: "ARCTIC SKY", value: "ARCTIC SKY" },
      { label: "AUSTER", value: "AUSTER" },
      { label: "BLACKBEARD", value: "BLACKBEARD" },
      { label: "BRILLIANT WHITE", value: "BRILLIANT WHITE" },
      { label: "BURGUNDY", value: "BURGUNDY" },
      { label: "CHERRY", value: "CHERRY" },
      { label: "CREAM", value: "CREAM" },
      { label: "DOVE GREY", value: "DOVE GREY" },
      { label: "DUNE", value: "DUNE" },
      { label: "IVORY", value: "IVORY" },
      { label: "MOCCA", value: "MOCCA" },
      { label: "OCHRE", value: "OCHRE" },
      { label: "OFF WHITE", value: "OFF WHITE" },
      { label: "PAPAYA", value: "PAPAYA" },
      { label: "PARCHMENT", value: "PARCHMENT" },
      { label: "PEARL GREY", value: "PEARL GREY" },
      { label: "PURE WHITE", value: "PURE WHITE" },
      { label: "TRUE BLUE", value: "TRUE BLUE" },
      { label: "WHITE CAP", value: "WHITE CAP" },
      { label: "PEACH", value: "PEACH" },
      { label: "MINK", value: "MINK" },
      { label: "CLAY", value: "CLAY" },
      { label: "HAVANNA", value: "HAVANNA" },
      { label: "MUD", value: "MUD" },
      { label: "FLIPPER", value: "FLIPPER" },
      { label: "ANGEL", value: "ANGEL" },
      { label: "ALPINE", value: "ALPINE" },
      { label: "ASPHALT", value: "ASPHALT" },
      { label: "MERMAID", value: "MERMAID" },
      { label: "EDAMAME", value: "EDAMAME" },
      { label: "CAMOUFLAGE", value: "CAMOUFLAGE" }
    ]
  },
  {
    label: "MOSAIQUE",
    value: "MOSAIQUE",
    colors: [
      { label: "IBIS", value: "IBIS" },
      { label: "PETROLEUM", value: "PETROLEUM" },
      { label: "DAKOTA", value: "DAKOTA" },
      { label: "COCONUT", value: "COCONUT" },
      { label: "HUMUS", value: "HUMUS" }
    ]
  },
  {
    label: "NAUTILUS",
    value: "NAUTILUS",
    colors: [
      { label: "MARSHMALLOW", value: "MARSHMALLOW" },
      { label: "ASPARAGUS", value: "ASPARAGUS" },
      { label: "PRISTINE", value: "PRISTINE" },
      { label: "SANDSHELL", value: "SANDSHELL" },
      { label: "ALMOND", value: "ALMOND" },
      { label: "GLACIER", value: "GLACIER" },
      { label: "CONCRETE", value: "CONCRETE" },
      { label: "OBSIDIAN", value: "OBSIDIAN" },
      { label: "ECLIPSE", value: "ECLIPSE" },
      { label: "COBALT", value: "COBALT" },
      { label: "INSIGNIA", value: "INSIGNIA" },
      { label: "MUSHROOM", value: "MUSHROOM" },
      { label: "BRAMBLE", value: "BRAMBLE" }
    ]
  },
  {
    label: "NUANCE",
    value: "NUANCE",
    colors: [
      { label: "SNOW WHITE", value: "SNOW WHITE" },
      { label: "DARK GRAPHITE", value: "DARK GRAPHITE" },
      { label: "COFFEE BEAN", value: "COFFEE BEAN" },
      { label: "COGNAC", value: "COGNAC" }
    ]
  },
  {
    label: "PEGASUS",
    value: "PEGASUS",
    colors: [
      { label: "MIDNIGHT", value: "MIDNIGHT" },
      { label: "PEBBLE", value: "PEBBLE" },
      { label: "BRILLIANT WHITE", value: "BRILLIANT WHITE" },
      { label: "EBONY", value: "EBONY" },
      { label: "GUNMETAL", value: "GUNMETAL" },
      { label: "SAND DOLLAR", value: "SAND DOLLAR" }
    ]
  },
  {
    label: "PIRAMIDE",
    value: "PIRAMIDE",
    colors: [
      { label: "BLACK", value: "BLACK" }
    ]
  },
  {
    label: "POLARIS",
    value: "POLARIS",
    colors: [
      { label: "MIDNIGHT", value: "MIDNIGHT" },
      { label: "BRILLIANT WHITE", value: "BRILLIANT WHITE" },
      { label: "EBONY", value: "EBONY" },
      { label: "GUNMETAL", value: "GUNMETAL" },
      { label: "PEBBLE", value: "PEBBLE" },
      { label: "SAND DOLLAR", value: "SAND DOLLAR" }
    ]
  },
  {
    label: "RACING",
    value: "RACING",
    colors: [
      { label: "BLACK", value: "BLACK" }
    ]
  },
  {
    label: "RALLY",
    value: "RALLY",
    colors: [
      { label: "BLACK", value: "BLACK" }
    ]
  },
  {
    label: "SAFFIANO",
    value: "SAFFIANO",
    colors: [
      { label: "QUARTZ", value: "QUARTZ" },
      { label: "AVORIO", value: "AVORIO" },
      { label: "PALLADIUM", value: "PALLADIUM" },
      { label: "MAGNET", value: "MAGNET" }
    ]
  },
  {
    label: "SANDSTONE",
    value: "SANDSTONE",
    colors: [
      { label: "OYSTER", value: "OYSTER" },
      { label: "GRAVEL", value: "GRAVEL" },
      { label: "STEEL", value: "STEEL" },
      { label: "MARBLE", value: "MARBLE" },
      { label: "OPAL", value: "OPAL" }
    ]
  },
  {
    label: "SCRIBE",
    value: "SCRIBE",
    colors: [
      { label: "BEIGE", value: "BEIGE" },
      { label: "GRAPHITE", value: "GRAPHITE" },
      { label: "SANDSTONE", value: "SANDSTONE" },
      { label: "COFFEE", value: "COFFEE" }
    ]
  },
  {
    label: "SHANTUNG",
    value: "SHANTUNG",
    colors: [
      { label: "MERCURY", value: "MERCURY" },
      { label: "NOCTURNE", value: "NOCTURNE" },
      { label: "WOOD", value: "WOOD" },
      { label: "CAMEL", value: "CAMEL" },
      { label: "CUMMULUS", value: "CUMMULUS" },
      { label: "BISCOTTO", value: "BISCOTTO" }
    ]
  },
  {
    label: "SIERRA C5",
    value: "SIERRA C5",
    colors: [
      { label: "SCHWARZ", value: "SCHWARZ" },
      { label: "WEISS", value: "WEISS" },
      { label: "NEBEL", value: "NEBEL" },
      { label: "WASSER", value: "WASSER" },
      { label: "HEIDE", value: "HEIDE" },
      { label: "JEAN", value: "JEAN" },
      { label: "HELLGRUN", value: "HELLGRUN" },
      { label: "LACHS", value: "LACHS" },
      { label: "BRAUN", value: "BRAUN" },
      { label: "CHIANTI", value: "CHIANTI" },
      { label: "GRÜN", value: "GRÜN" },
      { label: "LEINEN", value: "LEINEN" },
      { label: "MOCCA", value: "MOCCA" },
      { label: "ROT", value: "ROT" },
      { label: "DELFT", value: "DELFT" },
      { label: "MARINE", value: "MARINE" },
      { label: "PERLE", value: "PERLE" },
      { label: "GELB", value: "GELB" }
    ]
  },
  {
    label: "SILVERTEX",
    value: "SILVERTEX",
    colors: [
      { label: "ALUMINIUM", value: "ALUMINIUM" },
      { label: "AUBERGINE", value: "AUBERGINE" },
      { label: "AVOCADO", value: "AVOCADO" },
      { label: "BALTIC", value: "BALTIC" },
      { label: "BASIL", value: "BASIL" },
      { label: "BEIGE", value: "BEIGE" },
      { label: "BLACK", value: "BLACK" },
      { label: "BOTTLE", value: "BOTTLE" },
      { label: "BRICK", value: "BRICK" },
      { label: "CAMEL", value: "CAMEL" },
      { label: "CARBON", value: "CARBON" },
      { label: "CELERY", value: "CELERY" },
      { label: "CHAMPAGNE", value: "CHAMPAGNE" },
      { label: "COBRE", value: "COBRE" },
      { label: "CORAL", value: "CORAL" },
      { label: "CREAM", value: "CREAM" },
      { label: "DEEPSEA", value: "DEEPSEA" },
      { label: "DELFT", value: "DELFT" },
      { label: "FOREST", value: "FOREST" },
      { label: "GOJI", value: "GOJI" },
      { label: "GRAPHITE", value: "GRAPHITE" },
      { label: "GRENADINE", value: "GRENADINE" },
      { label: "HUNTER", value: "HUNTER" },
      { label: "ICE", value: "ICE" },
      { label: "ICE CREAM", value: "ICE CREAM" },
      { label: "JET", value: "JET" },
      { label: "JUNGLE", value: "JUNGLE" },
      { label: "LOTUS", value: "LOTUS" },
      { label: "LUGGAGE", value: "LUGGAGE" },
      { label: "MACADAMIA", value: "MACADAMIA" },
      { label: "MANDARIN", value: "MANDARIN" },
      { label: "MELON", value: "MELON" },
      { label: "METEOR", value: "METEOR" },
      { label: "MIZZLE", value: "MIZZLE" },
      { label: "MOCCA", value: "MOCCA" },
      { label: "ORANGE", value: "ORANGE" },
      { label: "ORCHID", value: "ORCHID" },
      { label: "PETROL", value: "PETROL" },
      { label: "PISTACHO", value: "PISTACHO" },
      { label: "PLATA", value: "PLATA" },
      { label: "RASPBERRY", value: "RASPBERRY" },
      { label: "RED", value: "RED" },
      { label: "ROSÉ", value: "ROSÉ" },
      { label: "RUBIN", value: "RUBIN" },
      { label: "SAFRAN", value: "SAFRAN" },
      { label: "SAGE", value: "SAGE" },
      { label: "SANDSTONE", value: "SANDSTONE" },
      { label: "SAPPHIRE", value: "SAPPHIRE" },
      { label: "SHIITAKE", value: "SHIITAKE" },
      { label: "SISAL", value: "SISAL" },
      { label: "SKYLIGHT", value: "SKYLIGHT" },
      { label: "SMOG", value: "SMOG" },
      { label: "SQUASH", value: "SQUASH" },
      { label: "STERLING", value: "STERLING" },
      { label: "STORM", value: "STORM" },
      { label: "SUNKIST", value: "SUNKIST" },
      { label: "TAUPE", value: "TAUPE" },
      { label: "TEAL", value: "TEAL" },
      { label: "TITANIUM", value: "TITANIUM" },
      { label: "TOMATO", value: "TOMATO" },
      { label: "TURQUOISE", value: "TURQUOISE" },
      { label: "UMBER", value: "UMBER" },
      { label: "WHALE", value: "WHALE" },
      { label: "WHITE", value: "WHITE" },
      { label: "WINDY", value: "WINDY" },
      { label: "WINE", value: "WINE" },
      { label: "CITRUS", value: "CITRUS" },
      { label: "MAGENTA", value: "MAGENTA" },
      { label: "ULTRA VIOLET", value: "ULTRA VIOLET" }
    ]
  },
  {
    label: "SILVERTEX B1",
    value: "SILVERTEX B1",
    colors: [
      { label: "BLACK", value: "BLACK" },
      { label: "MOCCA", value: "MOCCA" },
      { label: "ICE", value: "ICE" },
      { label: "ICE CREAM", value: "ICE CREAM" },
      { label: "MACADAMIA", value: "MACADAMIA" },
      { label: "BEIGE", value: "BEIGE" },
      { label: "SQUASH", value: "SQUASH" },
      { label: "CAMEL", value: "CAMEL" },
      { label: "TAUPE", value: "TAUPE" },
      { label: "METEOR", value: "METEOR" },
      { label: "ORANGE", value: "ORANGE" },
      { label: "GRENADINE", value: "GRENADINE" },
      { label: "RED", value: "RED" },
      { label: "RASPBERRY", value: "RASPBERRY" },
      { label: "TEAL", value: "TEAL" },
      { label: "JET", value: "JET" },
      { label: "DELFT", value: "DELFT" },
      { label: "SKYLIGHT", value: "SKYLIGHT" },
      { label: "ORCHID", value: "ORCHID" },
      { label: "ROSÉ", value: "ROSÉ" },
      { label: "AVOCADO", value: "AVOCADO" },
      { label: "CITRUS", value: "CITRUS" },
      { label: "ALUMINIUM", value: "ALUMINIUM" },
      { label: "STERLING", value: "STERLING" },
      { label: "CARBON", value: "CARBON" }
    ]
  },
  {
    label: "SILVERTEX C5",
    value: "SILVERTEX C5",
    colors: [
      { label: "MACADAMIA", value: "MACADAMIA" },
      { label: "AUBERGINE", value: "AUBERGINE" },
      { label: "BALTIC", value: "BALTIC" },
      { label: "BASIL", value: "BASIL" },
      { label: "BEIGE", value: "BEIGE" },
      { label: "CARBON", value: "CARBON" },
      { label: "COBRE", value: "COBRE" },
      { label: "DELFT", value: "DELFT" },
      { label: "ICE", value: "ICE" },
      { label: "MAGENTA", value: "MAGENTA" },
      { label: "MANDARIN", value: "MANDARIN" },
      { label: "METEOR", value: "METEOR" },
      { label: "PISTACHO", value: "PISTACHO" },
      { label: "PLATA", value: "PLATA" },
      { label: "RED", value: "RED" },
      { label: "RUBIN", value: "RUBIN" },
      { label: "SAFRAN", value: "SAFRAN" },
      { label: "SANDSTONE", value: "SANDSTONE" },
      { label: "SAPPHIRE", value: "SAPPHIRE" },
      { label: "SISAL", value: "SISAL" },
      { label: "STORM", value: "STORM" },
      { label: "TAUPE", value: "TAUPE" },
      { label: "TURQUOISE", value: "TURQUOISE" },
      { label: "CREAM", value: "CREAM" },
      { label: "MOCCA", value: "MOCCA" }
    ]
  },
  {
    label: "SILVERTEX E-SENSE",
    value: "SILVERTEX E-SENSE",
    colors: [
      { label: "ALUMINIUM", value: "ALUMINIUM" },
      { label: "AUBERGINE", value: "AUBERGINE" },
      { label: "AVOCADO", value: "AVOCADO" },
      { label: "BALTIC", value: "BALTIC" },
      { label: "BASIL", value: "BASIL" },
      { label: "BEIGE", value: "BEIGE" },
      { label: "BLACK", value: "BLACK" },
      { label: "BOTTLE", value: "BOTTLE" },
      { label: "BRICK", value: "BRICK" },
      { label: "CAMEL", value: "CAMEL" },
      { label: "CARBON", value: "CARBON" },
      { label: "CELERY", value: "CELERY" },
      { label: "CHAMPAGNE", value: "CHAMPAGNE" },
      { label: "COBRE", value: "COBRE" },
      { label: "CORAL", value: "CORAL" },
      { label: "CREAM", value: "CREAM" },
      { label: "DEEPSEA", value: "DEEPSEA" },
      { label: "DELFT", value: "DELFT" },
      { label: "FOREST", value: "FOREST" },
      { label: "GOJI", value: "GOJI" },
      { label: "GRAPHITE", value: "GRAPHITE" },
      { label: "GRENADINE", value: "GRENADINE" },
      { label: "HUNTER", value: "HUNTER" },
      { label: "ICE", value: "ICE" },
      { label: "ICECREAM", value: "ICECREAM" },
      { label: "JET", value: "JET" },
      { label: "JUNGLE", value: "JUNGLE" },
      { label: "LOTUS", value: "LOTUS" },
      { label: "LUGGAGE", value: "LUGGAGE" },
      { label: "MACADAMIA", value: "MACADAMIA" },
      { label: "MANDARIN", value: "MANDARIN" },
      { label: "MELON", value: "MELON" },
      { label: "METEOR", value: "METEOR" },
      { label: "MIZZLE", value: "MIZZLE" },
      { label: "MOCCA", value: "MOCCA" },
      { label: "ORANGE", value: "ORANGE" },
      { label: "ORCHID", value: "ORCHID" },
      { label: "PETROL", value: "PETROL" },
      { label: "PISTACHO", value: "PISTACHO" },
      { label: "PLATA", value: "PLATA" },
      { label: "RASPBERRY", value: "RASPBERRY" },
      { label: "RED", value: "RED" },
      { label: "ROSÉ", value: "ROSÉ" },
      { label: "RUBIN", value: "RUBIN" },
      { label: "SAFRAN", value: "SAFRAN" },
      { label: "SAGE", value: "SAGE" },
      { label: "SANDSTONE", value: "SANDSTONE" },
      { label: "SAPPHIRE", value: "SAPPHIRE" },
      { label: "SHIITAKE", value: "SHIITAKE" },
      { label: "SISAL", value: "SISAL" },
      { label: "SKYLIGHT", value: "SKYLIGHT" },
      { label: "SMOG", value: "SMOG" },
      { label: "SQUASH", value: "SQUASH" },
      { label: "STERLING", value: "STERLING" },
      { label: "STORM", value: "STORM" },
      { label: "SUNKIST", value: "SUNKIST" },
      { label: "TAUPE", value: "TAUPE" },
      { label: "TEAL", value: "TEAL" },
      { label: "TITANIUM", value: "TITANIUM" },
      { label: "TOMATO", value: "TOMATO" },
      { label: "TURQUOISE", value: "TURQUOISE" },
      { label: "UMBER", value: "UMBER" },
      { label: "WHALE", value: "WHALE" },
      { label: "WHITE", value: "WHITE" },
      { label: "WINDY", value: "WINDY" },
      { label: "WINE", value: "WINE" }
    ]
  },
  {
    label: "SKYLINE",
    value: "SKYLINE",
    colors: [
      { label: "SANTORINI", value: "SANTORINI" },
      { label: "ETOSHA", value: "ETOSHA" },
      { label: "SAHARA", value: "SAHARA" },
      { label: "CAPPADOCIA", value: "CAPPADOCIA" },
      { label: "PATAGONIA", value: "PATAGONIA" },
      { label: "KANSAI", value: "KANSAI" },
      { label: "JAIPUR", value: "JAIPUR" },
      { label: "MOJAVE", value: "MOJAVE" },
      { label: "MANHATTAN", value: "MANHATTAN" },
      { label: "VERSAILLES", value: "VERSAILLES" },
      { label: "ARRECIFE", value: "ARRECIFE" },
      { label: "KILKENNY", value: "KILKENNY" },
      { label: "MAYFAIR", value: "MAYFAIR" }
    ]
  },
  {
    label: "TANNERY",
    value: "TANNERY",
    colors: [
      { label: "ANCHOR", value: "ANCHOR" },
      { label: "MOCCACINO", value: "MOCCACINO" },
      { label: "MARACUYA", value: "MARACUYA" },
      { label: "ROYAL", value: "ROYAL" },
      { label: "CAOBA", value: "CAOBA" },
      { label: "PARAKEET", value: "PARAKEET" },
      { label: "PROVENCAL", value: "PROVENCAL" },
      { label: "SOIL", value: "SOIL" },
      { label: "SWAN", value: "SWAN" },
      { label: "MOONFLOWER", value: "MOONFLOWER" },
      { label: "SUGAR", value: "SUGAR" },
      { label: "BECHAMEL", value: "BECHAMEL" },
      { label: "ATACAMA", value: "ATACAMA" },
      { label: "SYRUP", value: "SYRUP" },
      { label: "BRANDY", value: "BRANDY" },
      { label: "HAZELNUT", value: "HAZELNUT" },
      { label: "MALBEC", value: "MALBEC" },
      { label: "DEEPWATER", value: "DEEPWATER" },
      { label: "DOLPHIN", value: "DOLPHIN" },
      { label: "PLASTER", value: "PLASTER" },
      { label: "SHARK", value: "SHARK" },
      { label: "SHADOW", value: "SHADOW" },
      { label: "PANTHER", value: "PANTHER" },
      { label: "BREEZE", value: "BREEZE" }
    ]
  },
  {
    label: "TRAX",
    value: "TRAX",
    colors: [
      { label: "STONE", value: "STONE" },
      { label: "SILVER", value: "SILVER" },
      { label: "ICE", value: "ICE" },
      { label: "BLACK", value: "BLACK" }
    ]
  },
  {
    label: "TWISTER",
    value: "TWISTER",
    colors: [
      { label: "BLACK", value: "BLACK" }
    ]
  },
  {
    label: "VALENCIA",
    value: "VALENCIA",
    colors: [
      { label: "AMETHYST", value: "AMETHYST" },
      { label: "APFEL", value: "APFEL" },
      { label: "AUSTER", value: "AUSTER" },
      { label: "AVOCADO", value: "AVOCADO" },
      { label: "AZURE", value: "AZURE" },
      { label: "BALTIC", value: "BALTIC" },
      { label: "BEIGE", value: "BEIGE" },
      { label: "BERRY", value: "BERRY" },
      { label: "BUCHE", value: "BUCHE" },
      { label: "CACTUS", value: "CACTUS" },
      { label: "CAMEL", value: "CAMEL" },
      { label: "CASHMERE", value: "CASHMERE" },
      { label: "CHAMPAGNE", value: "CHAMPAGNE" },
      { label: "CHESTNUT", value: "CHESTNUT" },
      { label: "CLOUD", value: "CLOUD" },
      { label: "COGNAC", value: "COGNAC" },
      { label: "CORAL", value: "CORAL" },
      { label: "DELFT", value: "DELFT" },
      { label: "EUCALYPTUS", value: "EUCALYPTUS" },
      { label: "EVEREST", value: "EVEREST" },
      { label: "FUNGI", value: "FUNGI" },
      { label: "GRAPHITE", value: "GRAPHITE" },
      { label: "GRÜN", value: "GRÜN" },
      { label: "IVORY (METALLIC)", value: "IVORY (METALLIC)" },
      { label: "JADE", value: "JADE" },
      { label: "KIRSCHE", value: "KIRSCHE" },
      { label: "LAUREL", value: "LAUREL" },
      { label: "LAVENDEL", value: "LAVENDEL" },
      { label: "LEINEN", value: "LEINEN" },
      { label: "LICHTGRAU", value: "LICHTGRAU" },
      { label: "LOTUS", value: "LOTUS" },
      { label: "MARINE", value: "MARINE" },
      { label: "MELONE", value: "MELONE" },
      { label: "MERLOT", value: "MERLOT" },
      { label: "METEOR", value: "METEOR" },
      { label: "MISTY", value: "MISTY" },
      { label: "MOCCA", value: "MOCCA" },
      { label: "MOSS", value: "MOSS" },
      { label: "MUSHROOM", value: "MUSHROOM" },
      { label: "NECTARINE", value: "NECTARINE" },
      { label: "NIGHT", value: "NIGHT" },
      { label: "OLIVE", value: "OLIVE" },
      { label: "ORANGE", value: "ORANGE" },
      { label: "PEACH", value: "PEACH" },
      { label: "PEARLESSENCE (METALLIC)", value: "PEARLESSENCE (METALLIC)" },
      { label: "PERLE", value: "PERLE" },
      { label: "PETROL", value: "PETROL" },
      { label: "PINE", value: "PINE" },
      { label: "PINK", value: "PINK" },
      { label: "PLATIN", value: "PLATIN" },
      { label: "PORT", value: "PORT" },
      { label: "PRALINÉ", value: "PRALINÉ" },
      { label: "PURE WHITE", value: "PURE WHITE" },
      { label: "ROSÉ", value: "ROSÉ" },
      { label: "ROT", value: "ROT" },
      { label: "SAFRAN", value: "SAFRAN" },
      { label: "SCHWARZ", value: "SCHWARZ" },
      { label: "SCUBA", value: "SCUBA" },
      { label: "SILVER (METALLIC)", value: "SILVER (METALLIC)" },
      { label: "SISAL", value: "SISAL" },
      { label: "SKYLIGHT", value: "SKYLIGHT" },
      { label: "SONNE", value: "SONNE" },
      { label: "SQUASH", value: "SQUASH" },
      { label: "SUMATRA", value: "SUMATRA" },
      { label: "TAUPE", value: "TAUPE" },
      { label: "TEAL", value: "TEAL" },
      { label: "TERRACOTTA", value: "TERRACOTTA" },
      { label: "TITAN", value: "TITAN" },
      { label: "TOMATO", value: "TOMATO" },
      { label: "TÜRKIS", value: "TÜRKIS" },
      { label: "WARM GREY", value: "WARM GREY" },
      { label: "WEISS", value: "WEISS" },
      { label: "BRONZE", value: "BRONZE" },
      { label: "CITRUS", value: "CITRUS" },
      { label: "GOLD (METALLIC)", value: "GOLD (METALLIC)" },
      { label: "ULTRA VIOLET", value: "ULTRA VIOLET" }
    ]
  },
  {
    label: "VALENCIA B1",
    value: "VALENCIA B1",
    colors: [
      { label: "SCHWARZ", value: "SCHWARZ" },
      { label: "MOCCA", value: "MOCCA" },
      { label: "SISAL", value: "SISAL" },
      { label: "LEINEN", value: "LEINEN" },
      { label: "CASHMERE", value: "CASHMERE" },
      { label: "SQUASH", value: "SQUASH" },
      { label: "CAMEL", value: "CAMEL" },
      { label: "TAUPE", value: "TAUPE" },
      { label: "CHESTNUT", value: "CHESTNUT" },
      { label: "ROT", value: "ROT" },
      { label: "KIRSCHE", value: "KIRSCHE" },
      { label: "PORT", value: "PORT" },
      { label: "TEAL", value: "TEAL" },
      { label: "NIGHT", value: "NIGHT" },
      { label: "DELFT", value: "DELFT" },
      { label: "SKYLIGHT", value: "SKYLIGHT" },
      { label: "BERRY", value: "BERRY" },
      { label: "ROSÉ", value: "ROSÉ" },
      { label: "AVOCADO", value: "AVOCADO" },
      { label: "CITRUS", value: "CITRUS" },
      { label: "AUSTER", value: "AUSTER" },
      { label: "PERLE", value: "PERLE" },
      { label: "GRAPHITE", value: "GRAPHITE" },
      { label: "PURE WHITE", value: "PURE WHITE" },
      { label: "ORANGE", value: "ORANGE" }
    ]
  },
  {
    label: "VALENCIA BIOSENSE",
    value: "VALENCIA BIOSENSE",
    colors: [
      { label: "SQUASH", value: "SQUASH" },
      { label: "SCHWARZ", value: "SCHWARZ" },
      { label: "GRAPHITE", value: "GRAPHITE" },
      { label: "TAUPE", value: "TAUPE" },
      { label: "SISAL", value: "SISAL" },
      { label: "PERLE", value: "PERLE" },
      { label: "WEISS", value: "WEISS" },
      { label: "DELFT", value: "DELFT" },
      { label: "ROT", value: "ROT" },
      { label: "PLATIN", value: "PLATIN" },
      { label: "LOTUS", value: "LOTUS" },
      { label: "AUSTER", value: "AUSTER" },
      { label: "MOCCA", value: "MOCCA" },
      { label: "ORANGE", value: "ORANGE" },
      { label: "METEOR", value: "METEOR" },
      { label: "BEIGE", value: "BEIGE" },
      { label: "PORT", value: "PORT" },
      { label: "TEAL", value: "TEAL" },
      { label: "NIGHT", value: "NIGHT" },
      { label: "PURE WHITE", value: "PURE WHITE" },
      { label: "AVOCADO", value: "AVOCADO" },
      { label: "SKYLIGHT", value: "SKYLIGHT" }
    ]
  },
  {
    label: "VALENCIA C5",
    value: "VALENCIA C5",
    colors: [
      { label: "EUCALYPTUS", value: "EUCALYPTUS" },
      { label: "MISTY", value: "MISTY" },
      { label: "CACTUS", value: "CACTUS" },
      { label: "PINE", value: "PINE" },
      { label: "PEACH", value: "PEACH" },
      { label: "SCUBA", value: "SCUBA" },
      { label: "AZURE", value: "AZURE" },
      { label: "CLOUD", value: "CLOUD" },
      { label: "FUNGI", value: "FUNGI" },
      { label: "EVEREST", value: "EVEREST" },
      { label: "COGNAC", value: "COGNAC" },
      { label: "GOLD", value: "GOLD" },
      { label: "BALTIC", value: "BALTIC" },
      { label: "AMETHYST", value: "AMETHYST" },
      { label: "APFEL", value: "APFEL" },
      { label: "AUSTER", value: "AUSTER" },
      { label: "BEIGE", value: "BEIGE" },
      { label: "BERRY", value: "BERRY" },
      { label: "BRONZE", value: "BRONZE" },
      { label: "BUCHE", value: "BUCHE" },
      { label: "DELFT", value: "DELFT" },
      { label: "GRAPHITE", value: "GRAPHITE" },
      { label: "GRÜN", value: "GRÜN" },
      { label: "JADE", value: "JADE" },
      { label: "KIRSCHE", value: "KIRSCHE" },
      { label: "LAUREL", value: "LAUREL" },
      { label: "LAVENDEL", value: "LAVENDEL" },
      { label: "LEINEN", value: "LEINEN" },
      { label: "LICHTGRAU", value: "LICHTGRAU" },
      { label: "MARINE", value: "MARINE" },
      { label: "MELONE", value: "MELONE" },
      { label: "METEOR", value: "METEOR" },
      { label: "MOCCA", value: "MOCCA" },
      { label: "OLIVE", value: "OLIVE" },
      { label: "ORANGE", value: "ORANGE" },
      { label: "PERLE", value: "PERLE" },
      { label: "PINK", value: "PINK" },
      { label: "PLATIN", value: "PLATIN" },
      { label: "PORT", value: "PORT" },
      { label: "PRALINÉ", value: "PRALINÉ" },
      { label: "ROT", value: "ROT" },
      { label: "SAFRAN", value: "SAFRAN" },
      { label: "SCHWARZ", value: "SCHWARZ" },
      { label: "SISAL", value: "SISAL" },
      { label: "SONNE", value: "SONNE" },
      { label: "TAUPE", value: "TAUPE" },
      { label: "TERRACOTTA", value: "TERRACOTTA" },
      { label: "TITAN", value: "TITAN" },
      { label: "TÜRKIS", value: "TÜRKIS" },
      { label: "WEISS", value: "WEISS" },
      { label: "CORAL", value: "CORAL" },
      { label: "SKYLIGHT", value: "SKYLIGHT" },
      { label: "NIGHT", value: "NIGHT" },
      { label: "CITRUS", value: "CITRUS" },
      { label: "AVOCADO", value: "AVOCADO" },
      { label: "SQUASH", value: "SQUASH" },
      { label: "TOMATO", value: "TOMATO" },
      { label: "LOTUS", value: "LOTUS" },
      { label: "ROSÉ", value: "ROSÉ" },
      { label: "CHESTNUT", value: "CHESTNUT" },
      { label: "CAMEL", value: "CAMEL" },
      { label: "CASHMERE", value: "CASHMERE" },
      { label: "ULTRA VIOLET", value: "ULTRA VIOLET" },
      { label: "TEAL", value: "TEAL" },
      { label: "WARM GREY", value: "WARM GREY" },
      { label: "PETROL", value: "PETROL" },
      { label: "PURE WHITE", value: "PURE WHITE" },
      { label: "IVORY", value: "IVORY" },
      { label: "PEARLESSENCE", value: "PEARLESSENCE" },
      { label: "SILVER", value: "SILVER" }
    ]
  },
  {
    label: "VALENCIA C5 HERITAGE COLLECTION",
    value: "VALENCIA C5 HERITAGE COLLECTION",
    colors: [
      { label: "LINEN", value: "LINEN" },
      { label: "DOESKIN", value: "DOESKIN" },
      { label: "TAN", value: "TAN" },
      { label: "GREIGE", value: "GREIGE" },
      { label: "BARK", value: "BARK" },
      { label: "AUTUMN", value: "AUTUMN" },
      { label: "TRERON", value: "TRERON" },
      { label: "DEUSEN", value: "DEUSEN" },
      { label: "JUBILEE", value: "JUBILEE" },
      { label: "GREYSTONE", value: "GREYSTONE" },
      { label: "CARAMEL", value: "CARAMEL" },
      { label: "BEETROOT", value: "BEETROOT" },
      { label: "ROUGE", value: "ROUGE" }
    ]
  },
  {
    label: "VALENCIA E-SENSE",
    value: "VALENCIA E-SENSE",
    colors: [
      { label: "AMETHYST", value: "AMETHYST" },
      { label: "APFEL", value: "APFEL" },
      { label: "AUSTER", value: "AUSTER" },
      { label: "AVOCADO", value: "AVOCADO" },
      { label: "AZURE", value: "AZURE" },
      { label: "BALTIC", value: "BALTIC" },
      { label: "BEIGE", value: "BEIGE" },
      { label: "BERRY", value: "BERRY" },
      { label: "BUCHE", value: "BUCHE" },
      { label: "CACTUS", value: "CACTUS" },
      { label: "CAMEL", value: "CAMEL" },
      { label: "CASHMERE", value: "CASHMERE" },
      { label: "CHAMPAGNE", value: "CHAMPAGNE" },
      { label: "CHESTNUT", value: "CHESTNUT" },
      { label: "CLOUD", value: "CLOUD" },
      { label: "COGNAC", value: "COGNAC" },
      { label: "CORAL", value: "CORAL" },
      { label: "DELFT", value: "DELFT" },
      { label: "EUCALYPTUS", value: "EUCALYPTUS" },
      { label: "EVEREST", value: "EVEREST" },
      { label: "FUNGI", value: "FUNGI" },
      { label: "GRAPHITE", value: "GRAPHITE" },
      { label: "GRÜN", value: "GRÜN" },
      { label: "IVORY", value: "IVORY" },
      { label: "JADE", value: "JADE" },
      { label: "KIRSCHE", value: "KIRSCHE" },
      { label: "LAUREL", value: "LAUREL" },
      { label: "LAVENDEL", value: "LAVENDEL" },
      { label: "LEINEN", value: "LEINEN" },
      { label: "LICHTGRAU", value: "LICHTGRAU" },
      { label: "LOTUS", value: "LOTUS" },
      { label: "MARINE", value: "MARINE" },
      { label: "MELONE", value: "MELONE" },
      { label: "MERLOT", value: "MERLOT" },
      { label: "METEOR", value: "METEOR" },
      { label: "MISTY", value: "MISTY" },
      { label: "MOCCA", value: "MOCCA" },
      { label: "MOSS", value: "MOSS" },
      { label: "MUSHROOM", value: "MUSHROOM" },
      { label: "NECTARINE", value: "NECTARINE" },
      { label: "NIGHT", value: "NIGHT" },
      { label: "OLIVE", value: "OLIVE" },
      { label: "ORANGE", value: "ORANGE" },
      { label: "PEACH", value: "PEACH" },
      { label: "PEARLESSENCE", value: "PEARLESSENCE" },
      { label: "PERLE", value: "PERLE" },
      { label: "PETROL", value: "PETROL" },
      { label: "PINE", value: "PINE" },
      { label: "PINK", value: "PINK" },
      { label: "PLATIN", value: "PLATIN" },
      { label: "PORT", value: "PORT" },
      { label: "PRALINÉ", value: "PRALINÉ" },
      { label: "PURE WHITE", value: "PURE WHITE" },
      { label: "ROSÉ", value: "ROSÉ" },
      { label: "ROT", value: "ROT" },
      { label: "SAFRAN", value: "SAFRAN" },
      { label: "SCHWARZ", value: "SCHWARZ" },
      { label: "SCUBA", value: "SCUBA" },
      { label: "SILVER", value: "SILVER" },
      { label: "SISAL", value: "SISAL" },
      { label: "SKYLIGHT", value: "SKYLIGHT" },
      { label: "SONNE", value: "SONNE" },
      { label: "SQUASH", value: "SQUASH" },
      { label: "SUMATRA", value: "SUMATRA" },
      { label: "TAUPE", value: "TAUPE" },
      { label: "TEAL", value: "TEAL" },
      { label: "TERRACOTTA", value: "TERRACOTTA" },
      { label: "TITAN", value: "TITAN" },
      { label: "TOMATO", value: "TOMATO" },
      { label: "TÜRKIS", value: "TÜRKIS" },
      { label: "WARM GREY", value: "WARM GREY" },
      { label: "WEISS", value: "WEISS" }
    ]
  },
  {
    label: "VELOURS",
    value: "VELOURS",
    colors: [
      { label: "PARAFFIN", value: "PARAFFIN" },
      { label: "COTTON", value: "COTTON" }
    ]
  },
  {
    label: "VENTURA",
    value: "VENTURA",
    colors: [
      { label: "BLACK", value: "BLACK" }
    ]
  },
  {
    label: "VESTIGE",
    value: "VESTIGE",
    colors: [
      { label: "ALOE", value: "ALOE" },
      { label: "ARAN", value: "ARAN" },
      { label: "CAMOUFLAGE", value: "CAMOUFLAGE" },
      { label: "COFFEE", value: "COFFEE" },
      { label: "COOL BLUE", value: "COOL BLUE" },
      { label: "CORN", value: "CORN" },
      { label: "ESCARLATA", value: "ESCARLATA" },
      { label: "FENNEL", value: "FENNEL" },
      { label: "FERN", value: "FERN" },
      { label: "INK", value: "INK" },
      { label: "INOX", value: "INOX" },
      { label: "JEAN", value: "JEAN" },
      { label: "MERMAID", value: "MERMAID" },
      { label: "NUT", value: "NUT" },
      { label: "OYSTER", value: "OYSTER" },
      { label: "RETRO BLUE", value: "RETRO BLUE" },
      { label: "RIOJA", value: "RIOJA" },
      { label: "ROBLE", value: "ROBLE" },
      { label: "SAND", value: "SAND" },
      { label: "SIBERIAN", value: "SIBERIAN" },
      { label: "SLATE", value: "SLATE" },
      { label: "TOFU", value: "TOFU" },
      { label: "WOLF", value: "WOLF" }
    ]
  },
  {
    label: "VESTIGE E-SENSE",
    value: "VESTIGE E-SENSE",
    colors: [
      { label: "ALOE", value: "ALOE" },
      { label: "ARAN", value: "ARAN" },
      { label: "CAMOUFLAGE", value: "CAMOUFLAGE" },
      { label: "COFFEE", value: "COFFEE" },
      { label: "COOL BLUE", value: "COOL BLUE" },
      { label: "CORN", value: "CORN" },
      { label: "ESCARLATA", value: "ESCARLATA" },
      { label: "FENNEL", value: "FENNEL" },
      { label: "FERN", value: "FERN" },
      { label: "INK", value: "INK" },
      { label: "INOX", value: "INOX" },
      { label: "JEAN", value: "JEAN" },
      { label: "MERMAID", value: "MERMAID" },
      { label: "NUT", value: "NUT" },
      { label: "OYSTER", value: "OYSTER" },
      { label: "RETRO BLUE", value: "RETRO BLUE" },
      { label: "RIOJA", value: "RIOJA" },
      { label: "ROBLE", value: "ROBLE" },
      { label: "SAND", value: "SAND" },
      { label: "SIBERIAN", value: "SIBERIAN" },
      { label: "SLATE", value: "SLATE" },
      { label: "TOFU", value: "TOFU" },
      { label: "WOLF", value: "WOLF" }
    ]
  },
  {
    label: "VOGUE",
    value: "VOGUE",
    colors: [
      { label: "CLOUD", value: "CLOUD" },
      { label: "VANILLA", value: "VANILLA" },
      { label: "EUCALYPTUS", value: "EUCALYPTUS" },
      { label: "LATTE", value: "LATTE" },
      { label: "MUSHROOM", value: "MUSHROOM" },
      { label: "STONE", value: "STONE" },
      { label: "COCOA", value: "COCOA" },
      { label: "GARNET", value: "GARNET" },
      { label: "APRICOT", value: "APRICOT" },
      { label: "NUGGET", value: "NUGGET" },
      { label: "LIME", value: "LIME" },
      { label: "MUSTARD", value: "MUSTARD" },
      { label: "CURRY", value: "CURRY" },
      { label: "SAGE", value: "SAGE" },
      { label: "SODA", value: "SODA" },
      { label: "GLACE", value: "GLACE" },
      { label: "WATER", value: "WATER" },
      { label: "SKY", value: "SKY" },
      { label: "DENIM", value: "DENIM" },
      { label: "STEEL", value: "STEEL" },
      { label: "ONYX", value: "ONYX" },
      { label: "CASHEW", value: "CASHEW" },
      { label: "EARTH", value: "EARTH" },
      { label: "TOPAZ", value: "TOPAZ" },
      { label: "CHARDONNAY", value: "CHARDONNAY" },
      { label: "PRUNE", value: "PRUNE" },
      { label: "DAHLIA", value: "DAHLIA" },
      { label: "FUCHSIA", value: "FUCHSIA" },
      { label: "SPACE", value: "SPACE" },
      { label: "NICKEL", value: "NICKEL" },
      { label: "PLATINUM", value: "PLATINUM" }
    ]
  },
  {
    label: "WALLTEX BI-ELASTIC",
    value: "WALLTEX BI-ELASTIC",
    colors: [
      { label: "CREAM", value: "CREAM" },
      { label: "CARBON", value: "CARBON" },
      { label: "MACADAMIA", value: "MACADAMIA" },
      { label: "ICE", value: "ICE" },
      { label: "TAUPE", value: "TAUPE" },
      { label: "METEOR", value: "METEOR" },
      { label: "MOCCA", value: "MOCCA" }
    ]
  },
  {
    label: "ZANDER",
    value: "ZANDER",
    colors: [
      { label: "CELESTIAL", value: "CELESTIAL" },
      { label: "APRICOT", value: "APRICOT" },
      { label: "AQUA MARINE", value: "AQUA MARINE" },
      { label: "ARCTIC SKY", value: "ARCTIC SKY" },
      { label: "AUSTER", value: "AUSTER" },
      { label: "BLACKBEARD", value: "BLACKBEARD" },
      { label: "BRILLIANT WHITE", value: "BRILLIANT WHITE" },
      { label: "BURGUNDY", value: "BURGUNDY" },
      { label: "CHERRY", value: "CHERRY" },
      { label: "CREAM", value: "CREAM" },
      { label: "DOVE GREY", value: "DOVE GREY" },
      { label: "DUNE", value: "DUNE" },
      { label: "FOREST", value: "FOREST" },
      { label: "IVORY", value: "IVORY" },
      { label: "LIGHT YELLOW", value: "LIGHT YELLOW" },
      { label: "MEDITERRANEE", value: "MEDITERRANEE" },
      { label: "MOCCA", value: "MOCCA" },
      { label: "OCHRE", value: "OCHRE" },
      { label: "OFF WHITE", value: "OFF WHITE" },
      { label: "PAPAYA", value: "PAPAYA" },
      { label: "PARCHMENT", value: "PARCHMENT" },
      { label: "PEARL GREY", value: "PEARL GREY" },
      { label: "PURE WHITE", value: "PURE WHITE" },
      { label: "TRUE BLUE", value: "TRUE BLUE" },
      { label: "WHITE CAP", value: "WHITE CAP" },
      { label: "YELLOW", value: "YELLOW" }
    ]
  }
]
